export const classNamePrefix = 'default-user-prefer';

export interface DataOption {
  key: string;
  title: string;
  invisible?: boolean;
  disabled?: boolean;
}
